//import {Dimensions} from 'react-native';

import { cf } from './cf';
//import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

export class cp { // common call def

  static $cp_hlr_cm10 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.cm10_key)) {
      _cnd = bf.q('[_KEY]={}'.f(
        pd.cm10_key,
      ));
    }
    else if (bf.f(pd.cm20_key)) {
      _cnd = bf.q(`[cm10b21k]="{}"`.f(
        pd.cm20_key,
      ));
    }

//bf.l('34: {}'.f(_cnd))
    cf.myCB_hlr({
      elm: 'cm10',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        return {
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_itemsDefs: _d_is => {
//bf.l('60: {}'.f(_d_is))
        return {
          pfx: '{}'.f(_d_is.cm10c310),
          b_dlt: (pd.b_wotDlt == true && _d_is.cm10cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });
  });

  static $cp_load_cm10 = (pd={
    mode: 'slc/items',
    b_clr: false,
    b_wotDlt : false, // without delete
    cm20_key: '',
  }) => new Promise( _o_end1 => { //  スタッフ情報 pd: {mode:'items', cm20_key:''}

    let _cnd = '';

    if (pd.cnd) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.cm10_key)) {
        _cnd = bf.q('[_KEY]={}'.f(
          pd.cm10_key,
        ));
      }
      else if (bf.f(pd.cm20_key)) {
        _cnd = bf.q(`[cm10b21k]="{}"`.f(
          pd.cm20_key,
        ));
      };
    };

//bf.l('101: {}'.f(_cnd))
    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm10', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm10s => {
            _o_end2(_d_cm10s);
          });
        };
      })
      .then( _d_cm10s => {
        if (bf.f(_d_cm10s)) {
//bf.l('121: {}'.f(_d_cm10s))
          global.c?.setState({
            sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
              _next.cm10c310 = _d_cm10s.cm10c310; // 本名
              _next.cm10c330 = _d_cm10s.cm10c330; // ニックネーム・源氏名
            }),
            s_cm10b21k: _d_cm10s.cm10b21k,
            s_cm10c120: _d_cm10s.cm10c120 || '',
            s_cm10c310: _d_cm10s.cm10c310,
            s_cm10c320: _d_cm10s.cm10c320,
            s_cm10c330: _d_cm10s.cm10c330,
            s_cm10c410: _d_cm10s.cm10c410 || '10',
            s_cm10cz10: _d_cm10s.cm10cz10 || '10',
            s_cm10cx10: _d_cm10s.cm10cx10 || '9999',
            s_cm10cw10: _d_cm10s.cm10cw10 || bf.myCM_gnr(10),
            s_cm10i110: _d_cm10s.cm10i110,
          }, ()=>{
            _o_end1(_d_cm10s);
          });
        }
        else {
          global.c?.setState({
            sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
              _next.cm10c310 = ''; // 本名
              _next.cm10c330 = ''; // ニックネーム・源氏名
            }),
            s_cm10b21k: '',
            s_cm10c120: '',
            s_cm10c310: '',
            s_cm10c320: '',
            s_cm10c330: '',
            s_cm10c410: '10',
            s_cm10cz10: '10',
            s_cm10cx10: '9999',
            s_cm10cw10: bf.myCM_gnr(10),
            s_cm10i110: '',
          }, ()=>{
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm', 
        elm: 'cm10', 
        n_dms: 3, 
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_cm10s => {
          return {
            pfx: '{}'.f(_d_cm10s.cm10c330, _d_cm10s.cm10cz10, ),
            b_dlt: (pd.b_wotDlt == true && _d_cm10s.cm10cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
          }
        }
      })
      .then( () => {
        _o_end1();
      });
    };
  });

  static $cp_ins_cm10 = (pd={}) => new Promise( _o_end1 => {
    cf.myRN_user_ins(global.c?.state.s_cm10i110)
    .then((_d_cm10s)=>{
      global.c?.setState({
        sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
          _next.cm10_key = _d_cm10s._KEY;
          _next.cm10c310 = global.c?.state.s_cm10c310;
        }),
      }, ()=>{
        _o_end1(_d_cm10s);
      })
    });
  });

  static $cp_upd_cm10 = (pd={}) => new Promise( _o_end1 => {
    cf.myRN_user_upd(global.c?.state.sgcd_pagePntKeys.cm10_key, global.c?.state.s_cm10i110)
    .then(()=>{
      //
      let _d_vals = {
        cm10b21k: global.c?.state.sgcd_pagePntKeys.cm20_key || '', 
        cm10c120: global.c?.state.s_cm10c120 || '', 
        cm10c310: global.c?.state.s_cm10c310 || '',
        cm10c320: global.c?.state.s_cm10c320 || '',
        cm10c410: global.c?.state.s_cm10c410 || '10',
        cm10cz10: global.c?.state.s_cm10cz10 || '10',
        cm10cx10: global.c?.state.s_cm10cx10 || '9999',
        cm10cw10: global.c?.state.s_cm10cw10 || bf.myCM_gnr(10),
        cm10i110: bf.myCM_cnv('lwr', global.c?.state.s_cm10i110) || '',
      };
      let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pagePntKeys.cm10_key));
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'cm10', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        if (global.c?.state.sgcd_pagePntKeys.cm10_key == global.c?.state.sgc_cm10_key) { // 利用者区分の同期
          cf.myLS_set('cm10c410', global.c?.state.s_cm10c410)
          .then(()=>{
              _o_end1();
          })
        }
        else {
          _o_end1();
        };
      });
    });
  });

  static $cp_hlr_cm11 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else {
      if (bf.f(pd.cm10_key)) {
        _cnd = bf.q(`[cm11b11k]="{}"`.f(
          pd.cm10_key,
        ));
      };
    };

//bf.l('239: {}, {}, {}'.f(_cnd, pd.cnd, pd.cm10_key, global.c?.state.sgc_pageKey));
    cf.myCB_hlr({
      elm: 'cm11',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss,
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
      },
      od_setDefs: _d_is => {
        if (bf.f(_d_is)) {
          let _d = {
            s_cm11i110: _d_is.cm11i110 || '',
            s_cm11i120: _d_is.cm11i120 || '',
            s_cm11i130: _d_is.cm11i130 || '',
            s_cm11i210: _d_is.cm11i210 || '',
            s_cm11i220: _d_is.cm11i220 || '0',
            s_cm11i310: _d_is.cm11i310 || '0',
          };
          return _d;
        }
        else {
          let _d = {
            s_cm11i110: '',
            s_cm11i120: '',
            s_cm11i130: '',
            s_cm11i210: '',
            s_cm11i220: '0',
            s_cm11i310: '0',
          };
          return _d;
        };
      },
      od_insDefs: () => {
        return {
        };
      },
      od_updDefs: () => {
        return {
        };
      },
      od_upsDefs: () => {
        let _d = {
          cm11b11k: global.c?.state.sgcd_pagePntKeys.cm10_key || '',
          cm11i110: global.c?.state.s_cm11i110 || '',
          cm11i120: global.c?.state.s_cm11i120 || '',
          cm11i130: global.c?.state.s_cm11i130 || '',
          cm11i210: global.c?.state.s_cm11i210 || '',
          cm11i220: global.c?.state.s_cm11i220 || '0',
          cm11i310: global.c?.state.s_cm11i310 || '0',
        };
//bf.l('304:{}'.f(_d));
        return _d;
      },
      od_itemsDefs: _d_is => {
        return {
        }
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });
  });

static $cp_hlr_cm30 = (pd={
  mode: 'get/set/itemss/clds',
  b_clr: false, // get, set
  state: '', // items, clds
  cnd: '',
  ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
}) => new Promise( async _o_end1 => {

  let _cnd = ''

  if (bf.f(pd.cnd)) {
    _cnd = pd.cnd;
  }
  else if (bf.f(pd.cm30_key)) {
    _cnd = bf.q('[_KEY]={}'.f(
      pd.cm30_key,
    ));
  }
  else if (bf.f(pd.cm20_key)) {
    _cnd = bf.q(`[cm30b11k]="{}"`.f(
      pd.cm20_key,
    ));
  }

//bf.l('350:{}, {}'.f(pd.mode, _cnd))
  cf.myCB_hlr({
    elm: 'cm30',
    mode: pd.mode,
    b_clr: pd.b_clr,
    state: pd.state,
    cnd: _cnd,
    o_cndCw10: () => bf.q(`
      [cm30b11k]="{}" AND 
      [cm30cw10]="{}" AND
      [_KEY]<>{}
    `.f(
      global.c?.state.sgcd_pagePntKeys.cm20_key,
      global.c?.state.s_cm30cw10,
      global.c?.state.sgc_pageKey || '-1',
    )),
    ld_sortss: pd.ld_sortss || [
      { fld: 'cm30cz10', dtn: 'desc', mode: 'nmb'},
      { fld: 'cm30cx10', dtn: 'asc', mode: 'nmb'},
      { fld: 'cm30cw10', dtn: 'asc', mode: 'str'},
      { fld: '_KEY', dtn: 'asc', mode: 'nmb'},
    ],
    b_withCnd: false,
    do_rfrs: {
    },
    dld_pcksss: {
      cm30cz10: [
        {key: '0', pfx: '表示しない'},
        {key: '10', pfx: '表示する'},
      ],
    },
    od_setDefs: _d_is => {
      if (bf.f(_d_is)) {

        global.c?.setState({
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next.cm30c310 = _d_is.cm30c310;
          }),
        });

        let _d = {
          s_cm30c310: _d_is.cm30c310 || '',
          s_cm30cx10: _d_is.cm30cx10 || '9999',
          s_cm30cz10: _d_is.cm30cz10 || '10',
          s_cm30cw10: _d_is.cm30cw10 || '',
        };
//bf.l('366: {}'.f(_d))
        return _d;
      }
      else {

        global.c?.setState({
          sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
            _next.cm30c310 = '';
          }),
        });

        let _d = {
          s_cm30c310: '',
          s_cm30cx10: '9999',
          s_cm30cz10: '10',
          s_cm30cw10: bf.myCM_gnr(10),
        };
//bf.l('374: {}'.f(_d))
        return _d;
      };
    },
    od_insDefs: () => {
      let _d = {
        cm30b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
        cm30c110: '',
        cm30cx10: '9999',
        cm30cz10: '10',
      };
//bf.l('382: {}'.f(_d))
      return _d;
    },
    od_updDefs: () => {
      let _d = {
        cm30c310: global.c?.state.s_cm30c310 || '',
        cm30cx10: global.c?.state.s_cm30cx10 || '9999',
        cm30cz10: global.c?.state.s_cm30cz10 || '10',
        cm30cw10: global.c?.state.s_cm30cw10 || '',
      };
//bf.l('389: {}, {}'.f(_cnd, _d))
      return _d;
    },
    od_itemsDefs: _d_is => {
      let _d = {
        key: '{}'.f(_d_is._KEY),
        pfx: '{}'.f(_d_is.cm30c310),
        spf: '{}'.f(_d_is.cm30cz10),
//        b_dlt: (pd.b_wotDlt == true && _d_is.cm30cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
      };
//bf.l('400: {}, {}'.f(_d, _d_is))
      return _d;
    },
    od_fileDefs: _d_is => {
      return {
      }
    },
  })
  .then( _a_r =>{ // 'ins' の場合に必要
    _o_end1(_a_r);
  });
});

static op_loadCm31 = () => cf.myCB_call_tree({
  ctr: 'slc',
  state: 'sdld_cm31sss',
  dd_elmDefss: {
    cm31: { // alias
      ctr: 'slc',
      elm: 'cm31',
      n_dms: 3,
      o_cnd: _dd_prtss => {
        let _cnd = bf.q(`
          [cm31b11k]="{}" AND
          [cm31b31k]="{}" AND
          IFNULL([cm31cz10],"10")<>"0"
        `.f(
          global.c?.state.sgcd_pagePntKeys.cm20_key,
          global.c?.state.sgcd_pagePntKeys.cm10_key,
        ));
        return _cnd;
      },
    },
  },
});

static $cp_hlr_cm31 = (pd={
  mode: 'get/set/itemss/clds',
  b_clr: false, // get, set
  state: '', // items, clds
  cnd: '',
  ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
}) => new Promise( async _o_end1 => {

  let _cnd = ''

  if (bf.f(pd.cnd)) {
    _cnd = pd.cnd;
  }
  else if (bf.f(pd.cm30_key)) {
    _cnd = bf.q('[_KEY]={}'.f(
      pd.cm31_key,
    ));
  }
  else if (bf.f(pd.cm20_key)) {
    _cnd = bf.q(`[cm31b11k]="{}" AND IFNULL([cm31cz10],"10")<>"0"`.f(
      pd.cm20_key,
    ));
  }
  else if (bf.f(pd.cm30_key)) {
    _cnd = bf.q(`[cm31b21k]="{}" AND IFNULL([cm31cz10],"10")<>"0"`.f(
      pd.cm30_key,
    ));
  }
  else if (bf.f(pd.cm10_key)) {
    _cnd = bf.q(`[cm31b31k]="{}" AND IFNULL([cm31cz10],"10")<>"0"`.f(
      pd.cm10_key,
    ));
  }

//bf.l('448:{}'.f(_cnd))
  cf.myCB_hlr({
    elm: 'cm31',
    mode: pd.mode,
    b_clr: pd.b_clr,
    state: pd.state,
    cnd: _cnd,
    ld_sortss: pd.ld_sortss || [
      { fld: 'cm31cz10', dtn: 'desc', mode: 'nmb' },
      { fld: 'cm31c410', dtn: 'desc', mode: 'nmb' },
      { fld: 'cm10cz10', dtn: 'desc', mode: 'nmb' },
      { fld: 'cm10cx10', dtn: 'asc', mode: 'nmb' },
      { fld: 'cm10cw10', dtn: 'asc', mode: 'str' },
    ],
    b_withCnd: false,
    do_rfrs: {
      cm10: _d_is => bf.q(`[_KEY]={}`.f(
        _d_is.cm31b31k
      )),
    },
    dld_pcksss: {
    },
    od_setDefs: _d_is => {
      if (bf.f(_d_is)) {
        let _d = {
          s_cm31c410: _d_is.cm31c410 || '0',
          s_cm31cz10: _d_is.cm31cz10 || '10',
        };
        return _d;
      }
      else {
        let _d = {
          s_cm31c410: '0',
          s_cm31cz10: '10',
        };
        return _d;
      };
    },
    od_insDefs: () => {
      let _d = {
      };
      return _d;
    },
    od_updDefs: () => {
      let _d = {
      };
      return _d;
    },
    od_iudCldsDefs: _d_is => {
//bf.l('486: {}'.f(_d_is))
      let _d_vals = null;
      let _cnd = bf.q('[cm31b21k]="{}" AND [cm31b31k]="{}"'.f(
        global.c?.state.sgcd_pagePntKeys.cm30_key, 
        _d_is.cm31b31k
      ));
      if ( _d_is.mode == 'dlt' ) {
        _d_vals = {
          cm31cz10: '0',
        };
      };
      if ( _d_is.mode ==  'ins' ) {
        _d_vals = {
          cm31b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
          cm31b21k: global.c?.state.sgcd_pagePntKeys.cm30_key,
          cm31b31k: _d_is.cm31b31k,
          cm31c410: _d_is.cm31c410 || '10',
          cm31cz10: '10',
        };
      };
      if ( _d_is.mode == 'upd' ) {
        _d_vals = {
          cm31b11k: global.c?.state.sgcd_pagePntKeys.cm20_key,
          cm31b21k: global.c?.state.sgcd_pagePntKeys.cm30_key,
          cm31b31k: _d_is.cm31b31k,
          cm31c410: _d_is.cm31c410 || '10',
          cm31cz10: '10',
        };
      };
//bf.l('514: {}, {}'.f(_cnd, _d_vals))
      return {
        d_vals: _d_vals,
        cnd: _cnd,
        o_atr: () => new Promise( _o_end1 => {
          let _qry = bf.q(`
            UPDATE 
              [t_cm1i] 
            SET 
              [cm1ii410]=(
                SELECT 
                  CASE 
                    WHEN 
                      (
                        SELECT 
                          COUNT(*) 
                        FROM 
                          [t_cm31] 
                        WHERE 
                          [cm31b31k]=[cm1ib11k] AND 
                          [cm31c410]="20" AND 
                          IFNULL([cm31cz10],"10")<>"0"
                      )>0 
                    THEN 
                      "10" 
                    ELSE 
                      "0" 
                  END
              ) 
            WHERE 
              [cm1ib11k]="{}"
          `.f(
            _d_is.cm31b31k,
          ));
//bf.l('558: {}'.f(_qry));
          cf.myCB_call_iud({
            ctr: 'qry',
            elm: 'cm1i',
            qry: _qry,
          })
          .then(() => {
            _o_end1();
          });
        }),
      };
    },
    od_itemsDefs: _d_is => {
      let _d = {
      };
      return _d;
    },
    od_fileDefs: _d_is => {
      return {
      }
    },
  })
  .then( _a_r =>{ // 'ins' の場合に必要
    _o_end1(_a_r);
  });
});

  static $cp_hlr_cm40 = (pd={
    mode: 'get/set/itemss/clds',
    b_clr: false, // get, set
    state: '', // items, clds
    cnd: '',
    ld_sortss: [{fld:'_KEY', dtn:'asc/desc'}],
  }) => new Promise( async _o_end1 => {

    let _cnd = ''

    if (bf.f(pd.cnd)) {
      _cnd = pd.cnd;
    }
    else if (bf.f(pd.cm40_key)) {
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.cm40_key || ''
      ));
    }
/*
    else if (bf.f(pd.cm40l11k)) {
      _cnd = bf.q(`([cm40b11k] IN ("0", "{}")) AND [cm40l11e]="{}" AND [cm40l11k]="{}"`.f(
        pd.cm20_key || '',
        pd.cm40l11e || '',
        pd.cm40l11k || '',
      ));
    };
*/

//bf.l('352:{}, {}'.f(pd.mode, _cnd))
    cf.myCB_hlr({
      elm: 'cm40',
      mode: pd.mode,
      b_clr: pd.b_clr,
      state: pd.state,
      cnd: _cnd,
      ld_sortss: pd.ld_sortss || [
        {fld:'cm40cz10', dtn:'desc', mode: 'nmb'},
        {fld:'cm40cx10', dtn:'asc', mode: 'nmb'},
      ],
      b_withCnd: false,
      do_rfrs: {
      },
      dld_pcksss: {
        cm40t110: [
          {key: '0', pfx: '未設定'},
          {key: '10', pfx: '個人'},
          {key: '20', pfx: '部門'},
          {key: '30', pfx: '全社'},
          {key: '90', pfx: '全体共通'},
        ],
      },
      od_setDefs: _d_cm40s => {
        if (bf.f(_d_cm40s)) {
          return {
            s_cm40_key: _d_cm40s._KEY || '',
            s_cm40c310: _d_cm40s.cm40c310 || '',
            s_cm40cx10: _d_cm40s.cm40cx10 || '9999',
            s_cm40cz10: _d_cm40s.cm40cz10 || '10',
            s_cm40t110: _d_cm40s.cm40t110 || '20',
            s_cm40cw10: _d_cm40s.cm40cw10 || bf.myCM_gnr(10),
          };
        }
        else {
          return {
            s_cm40_key: '',
            s_cm40c310: '',
            s_cm40cx10: '9999',
            s_cm40cz10: '10',
            s_cm40t110: '20',
            s_cm40cw10: bf.myCM_gnr(10),
          };
        };
      },
      od_insDefs: () => {
        let _d = {
          cm40b11k: pd.cm40b11k || '0', // 法人情報
          cm40b21k: pd.cm40b21k || '0', // 部門情報
          cm40l11e: pd.cm40l11e || '',
          cm40l11k: pd.cm40l11k || '',
          cm40c110: '',
          cm40c310: global.c?.state.s_cm40c310 || '',
          cm40cx10: global.c?.state.s_cm40cx10 || '9999',
          cm40cz10: global.c?.state.s_cm40cz10 || '10',
          cm40t110: pd.cm40t110 || '',
          cm40cy10: bf.myDT_get_now(),
          cm40cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
          cm40cw10: global.c?.state.s_cm40cw10 || bf.myCM_gnr(10),
        };
//bf.l('389:{}'.f(_d));
        return _d;
      },
      od_updDefs: () => {
        let _d = {
          cm40c310: global.c?.state.s_cm40c310 || '',
          cm40cx10: global.c?.state.s_cm40cx10 || '9999',
          cm40cz10: global.c?.state.s_cm40cz10 || '10',
          cm40cy10: bf.myDT_get_now(),
          cm40cy20: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
//          cm40t110: global.c?.state.s_cm40t110 || '',
          cm40cw10: global.c?.state.s_cm40cw10 || bf.myCM_gnr(10),
        };
        return _d;
      },
      od_itemsDefs: _d_is => {
        let _d = {
          pfx: '{}'.f(
            _d_is.cm40c310
          ),
          spf: '{}'.f(
            _d_is.cm40t110
          ),
        };
//bf.l('417:{}'.f(_d));        
        return _d;
      },
      od_fileDefs: _d_is => {
        return {
        }
      },
    })
    .then( _a_r =>{ // 'ins' の場合に必要
      _o_end1(_a_r);
    });
  });

/*
  static $cp_load_cm40 = (pd={
    mode: 'set/items',
    b_clr: false,
    state: 'sld_cm40ss', // for items/clds
    cm40_key: '', // for set
    cm40l11e: '', // for items
    cm40l11k: '', // for items
    cm20_key: '', // for items
  }) => new Promise( _o_end1 => {

    let _cnd = '';
    if (bf.f(pd.cm40_key)) {
      _cnd = bf.q(`[_KEY]={}`.f(
        pd.cm40_key || ''
      ));
    }
//    else if (bf.f(pd.cm20_key)) {
    else if (bf.f(pd.cm40l11k)) {
//      _cnd = bf.q(`[cm40b11k]="{}" AND [cm40l11e]="{}" AND [cm40l11k]="{}"`.f(
      _cnd = bf.q(`([cm40b11k] IN ("0", "{}")) AND [cm40l11e]="{}" AND [cm40l11k]="{}"`.f(
        pd.cm20_key || '',
        pd.cm40l11e || '',
        pd.cm40l11k || '',
      ));
    };
//bf.l('240:{}, {}'.f(_cnd, pd));

    if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm40', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm40s => {
            _o_end2(_d_cm40s);
          });
        };
      })
      .then( _d_cm40s => {
        if (bf.f(_d_cm40s)) {
          global.c?.setState({
            s_cm40_key: _d_cm40s._KEY || '',
            s_cm40c310: _d_cm40s.cm40c310 || '',
            s_cm40cz10: _d_cm40s.cm40cz10 || '',
          }, () => {
            _o_end1(_d_cm40s);
          });
        }
        else {
          global.c?.setState({
            s_cm40_key: '',
            s_cm40c310: '',
          }, () => {
            _o_end1(null);
          });
        };
      });
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm40', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        o_fnc: _d_cm40s => {
          return {
            pfx: '{}'.f(
              _d_cm40s.cm40c310
            ),
          };
        }
      })
      .then(()=>{
        _o_end1();
      });
    };
  });
*/

/*
  static $cp_ins_cm40 = (pd={
    cm40l11e: '',
    cm40l11k: '',
  }) => new Promise( _o_end1 => {
    let _d_vals = {
//      cm40b11k: global.c?.state.sgcd_pagePntKeys.cm20_key, // 法人情報
      cm40b11k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0', // 法人情報
      cm40l11e: pd.cm40l11e || '',
      cm40l11k: pd.cm40l11k || '',
      cm40c110: '',
      cm40c310: global.c?.state.s_cm40c310,
    };
//bf.l('314:{}'.f(_d_vals));
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'cm40', 
      d_vals: _d_vals
    })
    .then( _d_cm40s => {
      _o_end1(_d_cm40s);
    });
  });

  static $cp_upd_cm40 = (pd={
  }) => new Promise( _o_end1 => {
    let _d_vals = {
      cm40c310: global.c?.state.s_cm40c310,
    };
    let _cnd = bf.q(`[_KEY]={}`.f(global.c?.state.sgc_pageKey));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'cm40', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then( () => {
      _o_end1();
    });
  });
*/

  static $cp_load_cm50 = (pd={
    b_wotDlt: false, // without delete
  }) => new Promise( _o_end1 => { // 商品情報

    let _cnd = '';
    if (pd.cm50_key) {
      _cnd = bf.q('[_KEY]={}'.f(
        pd.cm50_key
      ));
    }
    else if (pd.cm20_key) {
      _cnd = bf.q('[cm50b11k]="{}" {}'.f( // コースを除く
        pd.cm20_key,
        pd.cnd || '',
      ));
    };

    if (pd.mode == 'get') {
      if (pd.b_clr == true) {
        _o_end1(null);
      }
      else {
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm50', 
          n_dms: 2, 
          cnd: _cnd,
        })
        .then( _d_cm50s => {
          _o_end1(_d_cm50s);
        });
      };
    }
    else if (pd.mode == 'set') {
      new Promise( _o_end2 => {
        if (pd.b_clr == true) {
          _o_end2(null);
        }
        else {
          cf.myCB_call_slc({
            ctr: 'nlm', 
            elm: 'cm50', 
            n_dms: 2, 
            cnd: _cnd
          })
          .then( _d_cm50s => {
            _o_end2(_d_cm50s);
          });
        };
      })
      .then( _d_cm50s => {
        if (bf.f(_d_cm50s)) {
          global.c?.setState({ 
            s_cm50_key: _d_cm50s._KEY,
            s_cm50t110: _d_cm50s.cm50t110,
            s_cm50c310: _d_cm50s.cm50c310,
            s_cm50cx10: _d_cm50s.cm50cx10 || '0',
            s_cm50cz10: _d_cm50s.cm50cz10 || '10',
            s_cm50i110: _d_cm50s.cm50i110 || '0',
          }, ()=>{
            _o_end1(_d_cm50s);
          });
        }
        else {
          global.c?.setState({ 
            s_cm50_key: '',
            s_cm50t110: '',
            s_cm50c310: '',
            s_cm50cx10: '0',
            s_cm50cz10: '10',
            s_cm50i110: '0',
          }, ()=>{
            _o_end1(null);
          });
        };
      })
    }
    else if (pd.mode == 'items') {
      cf.myCB_set_items({
        ctr: 'nlm',
        elm: 'cm50', 
        n_dms: 3,
        state: pd.state, 
        cnd: _cnd,
        ld_sortss: [{fld:'cm50cx10', dtn:'asc'}],
        o_fnc: _d_cm50s => {
          return {
            pfx: '{}'.f(
              _d_cm50s.cm50c310
            ),
            b_dlt: (pd.b_wotDlt == true && _d_cm50s.cm50cz10 == '0') ? true : false, // b_wotDlt == true かつ cz10 == '0'
          };
        }
      })
      .then(()=>{
        _o_end1();
      });
    };
  });

  static $cp_upd_cm50 = (pd={}) => new Promise( _o_end1 => { // 商品情報 の反映
    let _d_vals = {
      cm50t110: global.c?.state.s_cm50t110,
      cm50c310: global.c?.state.s_cm50c310,
      cm50cx10: global.c?.state.s_cm50cx10 || '0',
      cm50cz10: global.c?.state.s_cm50cz10 || '10',
      cm50i110: global.c?.state.s_cm50i110 || '0',
      cm50i120: global.c?.state.s_cm50i120 || '0',
      cm50i130: global.c?.state.s_cm50i130 || '0',
      cm50i140: global.c?.state.s_cm50i140 || '0',
      cm50i150: global.c?.state.s_cm50i150 || '0',
    };
    let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey));
    cf.myCB_call_iud({
      ctr: 'upd', 
      elm: 'cm50', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then(()=>{
      _o_end1();
    });
  });

  static $cp_hlr_ct10 = (pd={ // ファイル情報
    mode: '', // upl, slc
    elm: '', // upl, slc 
    key: '', // upl, slc
    state: '', // upl, slc
  }) => {
    return new Promise( _o_end1 => {
      if (pd.mode == 'upd') {
//bf.l('1039: here')
        Promise.all(
          global.c?.state[pd.state]
          .map( async _d_files => {
//bf.l('1043: {}'.f(_d_files))
            if (_d_files.lct == 'int' && _d_files.b_dlt != true) { // upload の場合
              let _d = {
                ct10b11k: global.c?.state.sgcd_pagePntKeys.cm10_key || '0',
                ct10b21k: global.c?.state.sgcd_pagePntKeys.cm20_key || '0',
                ct10b31k: global.c?.state.sgcd_pagePntKeys.cm30_key || '0',
                ct10l11k: pd.key,
                ct10l11e: pd.elm,
                ct10l11k: pd.key,
                ct10t110: pd.ct10t110 || '',
                ct10c110: '',
                ct10c310: _d_files.name,
                ct10c610: '',
                ct10cy10: bf.myDT_get_now(),
                ct10cy20: global.c?.state.sgcd_pagePntKeys.cm10_key,
                ct10cz10: '10',
              };
//bf.l('1059: {}'.f(_d))
              await cf.myCB_call_iud({
                ctr: 'ins', 
                elm: 'ct10', 
                d_vals: _d,
              })
              .then( async _d_ct10s => {
//bf.l('1066: {}, {}'.f(pd.elm, _d_ct10s))
                await cf.myCB_call_upl({
                  elm: 'ct10', 
                  fld: 'ct10c610', 
                  key: _d_ct10s._KEY, 
                  d_files: _d_files
                })
                .then(() => {
//bf.l('1074: {}, {}'.f(pd.elm, _d_files))
//                  _o_end2();
                })
                .catch( _err => {
//bf.l('1079: {}, {}, {}'.f(pd.elm, _d_files, _err))
                });
              });
            }
            else if (_d_files.lct == 'ext' && _d_files.b_dlt == true) { // delete の場合
              let _d = {
                ct10cz10: '0',
              };
              let _cnd = bf.q(`[_KEY]={}`.f(_d_files._KEY))
              await cf.myCB_call_iud({
                ctr: 'upd', 
                elm: 'ct10', 
                d_vals: _d,
                cnd: _cnd,
              })
              .then(() => {
//                _o_end2();
              })
            }
          })
        )
        .then( () => {
//bf.l('1087: here')
          _o_end1();
        });
      };
      if (pd.mode == 'set') {
        let _cnd = pd.cnd;
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'ct10', 
          n_dms: 3, 
          cnd: _cnd,
          ld_sortss: pd.ld_sortss,
          dd_rfrss: pd.dd_rfrss,
        })
        .then(async (_ld_ct10ss) => {
          let _ld_filess = _ld_ct10ss
          .filter( _d_ct10s => (_d_ct10s.ct10c610) ? true : false )
          .map( _d_ct10s => {
            let _d_ct10c610s = bf.j(_d_ct10s.ct10c610);
            let _d = {
              _KEY: _d_ct10s._KEY,
              lct: 'ext',
              name: _d_ct10c610s.name,
              url: '{}/{}'.f(ic.g_url2, _d_ct10c610s.file),
              d_ct10s: _d_ct10s,
            };
            return _d;
          });
          global.c?.setState({
            [pd.state]: _ld_filess,
          }, () => {
            _o_end1();
          });
        });
      };
    })
  };

  static cld_onChgss = () => [
  ];

}
